import { FC } from "react";

const DescriptionText: FC<{ text: string }> = ({ text }) => {
  return (
    <p className="text-xl font-semibold justify-around tracking-wide py-10">
      {text}
    </p>
  );
};

export default DescriptionText;
